<template>
  <div v-title :data-title="title" class="shanDeng" id="deng">
    <!-- <div style="height: 80px; text-align: center">
      <p style="font-size: xx-large">{{ title }}</p>
    </div> -->
    <div id="luckEle">
      <table v-if="formset.length > 7">
        <tbody>
          <tr>
            <td id="luck-unit-0" class="luck-unit">
              <img
                class="drawpic"
                v-if="formset[0].ID != 0"
                :src="formset[0].Url"
              />
              <img
                class="drawpic"
                v-if="formset[0].ID == 0"
                src="../../assets/img/xiexie.png"
              />
              <!-- <p style="font-size: 12px">{{ formset[0].Prize }}</p> -->
            </td>
            <td id="luck-unit-1" class="luck-unit">
              <img
                class="drawpic"
                v-if="formset[1].ID != 0"
                :src="formset[1].Url"
              />
              <img
                class="drawpic"
                v-if="formset[1].ID == 0"
                src="../../assets/img/xiexie.png"
              />
              <!-- <p style="font-size: 12px">{{ formset[1].Prize }}</p> -->
            </td>
            <td id="luck-unit-2" class="luck-unit">
              <img
                class="drawpic"
                v-if="formset[2].ID != 0"
                :src="formset[2].Url"
              />
              <img
                class="drawpic"
                v-if="formset[2].ID == 0"
                src="../../assets/img/xiexie.png"
              />
              <!-- <p style="font-size: 12px">{{ formset[2].Prize }}</p> -->
            </td>
          </tr>
          <tr>
            <td id="luck-unit-7" class="luck-unit">
              <img
                class="drawpic"
                v-if="formset[7].ID != 0"
                :src="formset[7].Url"
              />
              <img
                class="drawpic"
                v-if="formset[7].ID == 0"
                src="../../assets/img/xiexie.png"
              />
              <!-- <p style="font-size: 12px">{{ formset[3].Prize }}</p> -->
            </td>
            <td id="btn" @click="StartDraw()">
              <img style="width: 100%" src="../../assets/img/cjBtn.png" />
            </td>
            <td id="luck-unit-3" class="luck-unit">
              <img
                class="drawpic"
                v-if="formset[3].ID != 0"
                :src="formset[3].Url"
              />
              <img
                class="drawpic"
                v-if="formset[3].ID == 0"
                src="../../assets/img/xiexie.png"
              />
              <!-- <p style="font-size: 12px">{{ formset[4].Prize }}</p> -->
            </td>
          </tr>
          <tr>
            <td id="luck-unit-6" class="luck-unit">
              <img
                class="drawpic"
                v-if="formset[6].ID != 0"
                :src="formset[6].Url"
              />
              <img
                class="drawpic"
                v-if="formset[6].ID == 0"
                src="../../assets/img/xiexie.png"
              />
              <!-- <p style="font-size: 12px">{{ formset[5].Prize }}</p> -->
            </td>
            <td id="luck-unit-5" class="luck-unit">
              <img
                class="drawpic"
                v-if="formset[5].ID != 0"
                :src="formset[5].Url"
              />
              <img
                class="drawpic"
                v-if="formset[5].ID == 0"
                src="../../assets/img/xiexie.png"
              />
              <!-- <p style="font-size: 12px">{{ formset[6].Prize }}</p> -->
            </td>
            <td id="luck-unit-4" class="luck-unit">
              <img
                class="drawpic"
                v-if="formset[4].ID != 0"
                :src="formset[4].Url"
              />
              <img
                class="drawpic"
                v-if="formset[4].ID == 0"
                src="../../assets/img/xiexie.png"
              />
              <!-- <p style="font-size: 12px">{{ formset[7].Prize }}</p> -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="play">
      <span v-if="false"></span>
      <div class="div">
        <div id="demo" class="qimo8">
          <div class="qimo">
            <div id="demo1">
              <ul>
                <li v-for="(model, $index) in wins" :key="$index">
                  {{ model }}
                </li>
              </ul>
            </div>
            <div id="demo2"></div>
          </div>
        </div>
      </div>
    </div>

    <wv-popup
      :visible.sync="popupProductInfo"
      style="width: 100%; padding: 20px; padding-bottom: 100px"
      class="pop-produce"
    >
      <div class="pop-pro-price">
        <p>{{ response.PrizeName }}</p>
      </div>
      <div class="pop-pro-select">
        <div class="select-btn">
          <wv-input
            placeholder="请输入姓名"
            label="姓名："
            v-model="logname"
            :max-length="10"
          ></wv-input>
        </div>
      </div>
      <div class="pop-pro-select">
        <div class="select-btn">
          <wv-input
            placeholder="请输入电话"
            label="电话："
            v-model="iphone"
            :max-length="20"
          ></wv-input>
        </div>
      </div>
      <div class="pop-pro-select">
        <div class="select-btn">
          <wv-input
            placeholder="请输入地址"
            label="地址："
            v-model="address"
            :max-length="100"
          ></wv-input>
        </div>
      </div>
      <button class="btn-block fix-b" @click="Shop()">确定</button>
    </wv-popup>
  </div>
</template>
<script>
function initScrollDiv() {
  //播报
  var demo = document.getElementById("demo");
  var demo1 = document.getElementById("demo1");
  var demo2 = document.getElementById("demo2");
  demo2.innerHTML = document.getElementById("demo1").innerHTML;
  function Marquee() {
    if (demo.scrollLeft - demo2.offsetWidth >= 0) {
      demo.scrollLeft -= demo1.offsetWidth;
    } else {
      demo.scrollLeft++;
    }
  }
  setInterval(Marquee, 10);
}
var luck = {
  index: 0, //当前转动到哪个位置，起点位置
  count: 0, //总共有多少个位置
  timer: 0, //setTimeout的ID，用clearTimeout清除
  speed: 20, //初始转动速度
  times: 0, //转动次数
  cycle: 50, //转动基本次数：即至少需要转动多少次再进入抽奖环节
  prize: -1, //中奖位置
  init: function (id) {
    var $luck = document.getElementById(id);
    var $units = $luck.getElementsByClassName("luck-unit");
    if ($units.length > 0) {
      this.obj = $luck;
      this.count = $units.length;
      document.getElementById("luck-unit-" + this.index).className =
        "luck-unit active";
    }
    initScrollDiv();
  },

  roll: function () {
    var index = this.index;
    var count = this.count;
    var luck = this.obj;
    var eles = document.getElementsByClassName("luck-unit");
    for (var i = 0; i < eles.length; i++) {
      document.getElementById("luck-unit-" + i).className = "luck-unit";
    }
    index += 1;
    if (index > count - 1) {
      index = 0;
    }
    document.getElementById("luck-unit-" + index).className =
      "luck-unit active";
    this.index = index;
    return false;
  },
  stop: function (index) {
    this.prize = index;
    return false;
  },
};

import thumb from "../../assets/logo.png";
import { Dialog, Toast } from "we-vue";
import luckplug from "@/components/my/luckplug";
export default {
  name: "draw",
  data: function () {
    return {
      logourl: thumb,
      title: "",
      drawID: "",
      luckprize: 1,
      formset: [],
      wins: [],
      response: {},
      luckObj: {},
      flag: false,
      address: "",
      iphone: "",
      logname: "",
      popupProductInfo: false,
    };
  },
  created: function () {
    var url = window.location.href;
    var id = this.GetRequest(url)["id"];
    if (id != undefined && id != null && id.length > 0) {
      this.drawID = id;
    }
    this.InitInfo();
  },
  methods: {
    InitInfo: function () {
      if (this.drawID != "") {
        this.$http
          .get(this.GLOBAL.BASE_URL + "api/draw/getdraw?id=" + this.drawID, {})
          .then(function (d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.formset = rep.Data;
              this.title = rep.Data[0].Name;

              setTimeout(function () {
                luck.init("luckEle");
              }, 1000);
            } else {
              Toast.fail(rep.Message);
            }
          });
        this.$http
          .get(
            this.GLOBAL.BASE_URL + "api/draw/getdrawwin?guid=" + this.drawID,
            {}
          )
          .then(function (d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.wins = rep.Data;
            } else {
              Toast.fail(rep.Message);
            }
          });
      }
    },
    roll: function () {
      luck.times += 1;
      luck.roll();
      if (luck.times > luck.cycle + 10 && luck.prize == luck.index) {
        // luck.roll();
        clearTimeout(luck.timer);
        luck.prize = -1;
        luck.times = 0;
        this.flag = false;
        if (this.response.IsAddress == true) {
          this.popupProductInfo = true;
        } else {
          if(this.response.PrizeName.indexOf("谢谢参与")>0)
          {
            this.response.PrizeName="谢谢参与";
          }
          Toast.success(this.response.PrizeName);
        }
      } 
      else {
        if (luck.times < luck.cycle) {
          luck.speed -= 10;
        } else if (luck.times == luck.cycle) {
          luck.prize = this.luckprize;
        } 
        else {
          if (luck.times > luck.cycle + 10 &&((luck.prize == 0 && luck.index == 7) ||luck.prize == luck.index + 1)) {
            luck.speed += 110;
          } else {
            luck.speed += 20;
          }
        }
        if (luck.speed < 40) {
          luck.speed = 40;
        }

        luck.timer = setTimeout(this.roll, luck.speed);
      }
      return false;
    },
    StartDraw: function () {
      //调用接口获得奖品信息，根据奖品判断是否需要弹出礼品邮寄地址div
      if (this.drawID != "") {
        this.$http
          .get(
            this.GLOBAL.BASE_URL + "api/draw/startdraw?id=" + this.drawID,
            {}
          )
          .then(function (d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.response = rep.Data;
              var luckprizes = [];
              for (var i = 0; i < 8; i++) {
                if (this.formset[i].ID == this.response.PrizeID) {
                  luckprizes.push(i);
                }
              }
              if (luckprizes.length > 0) {
                this.luckprize =
                  luckprizes[Math.floor(Math.random() * luckprizes.length)];
              }
              if (this.response.PrizeID == -1) {
                Toast.fail(this.response.PrizeName);
              } else {
                luck.speed = 100;
                this.roll();
                this.flag = true;
              }
            } else {
              Toast.fail(rep.Message);
            }
          });
      }
    },
    Shop: function () {
      if (this.address == "" || this.iphone == "" || this.logname == "") {
        Toast.fail("请填写邮寄资料");
        return;
      }
      var data = {
        RecordID: this.response.RecordID,
        address: this.address,
        iphone: this.iphone,
        logname: this.logname,
      };
      this.$http
        .post(this.GLOBAL.BASE_URL + "api/draw/addadress", data, {
          emulateJSON: true,
        })
        .then(function (d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            this.popupProductInfo = false;
            Toast.success("提交成功");
          } else {
            Toast.fail(rep.Message);
          }
        });
    },
  },
};
</script>

<style>
#luckEle {
  padding-top: 200px;
}
#luckEle table {
  border-spacing: 20px 0px;
  width: 90%;
}
.qimo8 {
  overflow: hidden;
}
.qimo8 .qimo {
  /*width:99999999px;*/
  width: 8000%;
}
.qimo8 .qimo div {
  float: left;
}
.qimo8 .qimo ul {
  float: left;
  overflow: hidden;
  zoom: 1;
}
.qimo8 .qimo ul li {
  float: left;
  list-style: none;
  font-size: 24px;
  margin: 0 1rem;
  color: #fff;
}

.drawpic {
  /* height: 90%;*/
  width: 100%;
}

.shanDeng {
  width: 100%;
  background-size: 100%;
  background-repeat: no-repeat;
  margin-bottom: 0.15rem;
  height: 100%;
  background-image: url(../../assets/img/bg-img.png);
  background-repeat: no-repeat;
  position: relative;
}

#btn .cjBtn,
.shanDeng .active,
.shanDeng td {
  width: 1.74rem;
  height: 1.48rem;
  background-repeat: no-repeat;
}

#btn.cjBtn {
  background-image: url(../../assets/img/cjBtn.png);
  background-size: 100% 100%;
}

#luckEle .active img {
  border: 5px solid #795bff;
  border-radius: 25px;
}
#luckEle img {
  border: 5px solid rgb(0 0 255 / 0);
  border-radius: 25px;
}
#btn img {
  border-radius: 0;
}
.shanDeng td {
  text-align: center;
  background-size: 100% 100%;
}
.shanDeng td img {
  background-image: url(../../assets/img/proBj.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.shanDeng table {
  margin: 0 auto;
}

/*rule s*/
.rule {
  margin: 0 auto;
  background-color: #e84a54;
  width: 4.3rem;
  height: 2.3rem;
  padding: 0 0.4rem;
}
.rule p {
  font-size: 26px;
  color: #fff;
  line-height: 0.38rem;
}
.rule p:first-child {
  text-align: center;
  font-size: 32px;
  line-height: 0.6rem;
}
/*rule e*/
.play {
  position: absolute;
  top: 0;
  /*width: 100%;
  background-color: #ffeab2;*/
}
.play .div {
  height: 100%;
  /*margin-left: 40px;
  border-left: 2px solid #e84a54;*/
}
.play span {
  background: url("../../assets/img/icon-laba.png") no-repeat;
  background-size: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 20px;
  width: 20px;
  margin: 0 10px;
}
</style>




// WEBPACK FOOTER //
// src/components/my/draw.vue